import React from "react";
import { AgGrid, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";

export const LoadingCellRenderer = (props: AgGrid.ICellRendererParams) => {
  if (props.node.failedLoad) {
    return (
      <Flex alignItems="center" gap={8} style={{ paddingLeft: "10px", lineHeight: "25px" }}>
        <Icon type="times" variant="solid" color={Colors.Danger600} />
        <Text style={{ color: Colors.Danger600 }}> Data failed to load</Text>
      </Flex>
    );
  }
  return null;
};
